import type { CheckConfig, CheckConfigField } from '@fkwd-qc/shared';

/**
 * The settings form's working copy of a client's overrides: every value as the text in its
 * control, so a number field can be emptied while it is edited.
 *
 * @since 1.5.0
 */
export type ConfigDraft = Record<string, string>;

/**
 * Turns the stored overrides into the form's working copy, one text value per declared field.
 *
 * @since 1.5.0
 * @param fields - the settings the check declares
 * @param config - the overrides on file
 * @returns the draft
 */
export function toConfigDraft(fields: CheckConfigField[], config: CheckConfig): ConfigDraft {
    return Object.fromEntries(
        fields.map((field) => {
            const value = config[field.key];
            return [field.key, value === null || value === undefined ? '' : String(value)];
        }),
    );
}
